module.exports = __webpack_public_path__ + "img/about-01.67447fe2.jpg";